var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefund({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.27,15.63a5.49,5.49,0,0,1-5.48,5.48H10.24a.6.6,0,0,1,0-1.2h6.55a4.28,4.28,0,1,0,0-8.56H10.33l3.07,2.54A.6.6,0,0,1,13,15a.64.64,0,0,1-.39-.14L8.29,11.21a.59.59,0,0,1,0-.92l4.34-3.61a.6.6,0,1,1,.77.92l-3.07,2.55h6.46A5.49,5.49,0,0,1,22.27,15.63Z",
    fill: "#fff"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefund);
export default __webpack_public_path__ + "static/media/refund.e58a8cfe43d3f5dc9452415c3bbc816c.svg";
export { ForwardRef as ReactComponent };